import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted, provide } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import CheckboxRounded from "@/components/widgets/input/CheckboxRounded.vue"
import ExpansionPanels from "@/components/widgets/accordion/ExpansionPanels.vue"
import ExpansionPanel from "@/components/widgets/accordion/ExpansionPanel.vue"
import ExpansionHeader from "@/components/widgets/accordion/ExpansionHeader.vue"
import ExpansionContent from "@/components/widgets/accordion/ExpansionContent.vue"
import {
  MissionLifecycleFragmentFragment,
  MissionScopePhase,
  MissionScopeActivity,
  UpdateMissionScopeActivityMutationMutation,
  UpdateMissionScopeActivityMutation,
  UpdateMissionScopeActivityMutationMutationVariables,
  CreateMissionScopeMutation,
  CreateMissionScopeMutationMutation,
  CreateMissionScopeMutationMutationVariables,
  ConsultantMissionLifecycle,
  ClientMissionLifecycleFragmentFragment,
} from "@/gql"
import { useUtilities } from "@/hooks/useUtilities"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import { useAccountContext } from "@/hooks/useAccountContext"
import { RefetchQueryDescription } from "apollo-client/core/watchQueryOptions"
import MissionScopeEditor2 from "@/components/missions/MissionScopeEditor2.vue"
import AppEditorWindow from "@/components/layout/AppEditorWindow.vue"
import { useMissionLifecycleContext } from "../../hooks/useMissionLifecycleContext"


export default /*#__PURE__*/_defineComponent({
  __name: 'ScopeOverview',
  props: {
    mission: null,
    refetchQueries: null
  },
  setup(__props: any) {

const props = __props as {
  mission:
    | MissionLifecycleFragmentFragment
    | ConsultantMissionLifecycle
    | ClientMissionLifecycleFragmentFragment
  refetchQueries: RefetchQueryDescription
}



const activityLoadings = ref<Record<string, boolean>>({})
const completedActivities = ref<Record<string, boolean>>({})
const isSubmitting = ref(false)

const { formatDate } = useUtilities()
const { mutate } = useMutation()
const { isCoreTeam: isUserInCoreTeam, isClient } = useAccountContext()
const { addSuccess } = useNotification()

const missionScope = computed(() => {
  return props.mission.missionScope
})

const phases = computed(() => {
  return missionScope.value?.phases
})

const getPhaseCompletion = (phase: MissionScopePhase) => {
  if (!phase.activities.length) return 0

  const completed = phase.activities.filter((a) => a.completed).length
  return Math.round((completed / phase.activities.length) * 100)
}

const onActivityStatusChange = async (activity: MissionScopeActivity, checked: boolean) => {
  const id = activity.prn
  const newActivityCompletionState = checked

  activityLoadings.value[id] = true

  const result = await mutate<
    UpdateMissionScopeActivityMutationMutation,
    UpdateMissionScopeActivityMutationMutationVariables
  >({
    mutation: UpdateMissionScopeActivityMutation,
    variables: {
      missionScopeActivityId: id,
      completed: newActivityCompletionState,
    },
    done: () => {
      activityLoadings.value[id] = false
    },
  })

  if (result?.data?.updateMissionScopeActivity && !result.data.updateMissionScopeActivity.error) {
    completedActivities.value[id] = newActivityCompletionState
    activity.completed = newActivityCompletionState
  }

  activityLoadings.value = { ...activityLoadings.value }
}

const onCreateScope = async () => {
  isSubmitting.value = true

  const result = await mutate<
    CreateMissionScopeMutationMutation,
    CreateMissionScopeMutationMutationVariables
  >({
    mutation: CreateMissionScopeMutation,
    variables: {
      missionLifecycleId: props.mission.prn,
      missionScopePhases: null,
    },
    refetchQueries: props.refetchQueries,
    done: () => {
      isSubmitting.value = false
    },
  })

  if (result && !result?.data?.createMissionScope.error) {
    addSuccess("Scope created successfully")
  }
}

onMounted(() => {
  if (missionScope.value) {
    completedActivities.value = missionScope.value.activities.reduce((completed, activity) => {
      completed[activity.id] = activity.completed
      return completed
    }, {} as Record<string, boolean>)
  }
})

const showScopeModal = ref(false)
const scopeModal = ref(null)

const scopeSection = ref("activities")

const onEditScopeDialogChange = (page: string) => {
  scopeSection.value = page
}

const onSaveScope = () => {
  ;(scopeModal.value as any).save()
}

const onSavingScope = (value = true) => {
  ;(scopeModal.value as any).applySaving(value)
}

const { refetch } = useMissionLifecycleContext()

const onCloseScopeModal = () => {
  showScopeModal.value = false
  refetch()
}

provide("refetchQueries", props.refetchQueries)

return { __sfc: true,props, activityLoadings, completedActivities, isSubmitting, formatDate, mutate, isUserInCoreTeam, isClient, addSuccess, missionScope, phases, getPhaseCompletion, onActivityStatusChange, onCreateScope, showScopeModal, scopeModal, scopeSection, onEditScopeDialogChange, onSaveScope, onSavingScope, refetch, onCloseScopeModal, Icon, CheckboxRounded, ExpansionPanels, ExpansionPanel, ExpansionHeader, ExpansionContent, MissionScopeEditor2, AppEditorWindow }
}

})